<script setup>

</script>

<template>
  <div class="inline-block relative">
    <svg
      width="62"
      height="64"
      viewBox="0 0 62 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="absolute center-icon"
    >
      <path
        d="M25.4273 6.71795C14.6361 6.71795 5.8568 15.7342 5.8568 26.8165C5.8568 37.899 14.6361 46.9152 25.4274 46.9152C36.2186 46.9152 44.9979 37.899 44.9979 26.8166C44.9979 21.448 42.9622 16.4008 39.2658 12.6047C35.5694 8.80856 30.6548 6.71795 25.4273 6.71795ZM25.4273 0.703125C25.4282 0.703125 25.4265 0.703125 25.4274 0.703125C39.4705 0.703125 50.8547 12.3945 50.8547 26.8166C50.8547 41.2386 39.4705 52.93 25.4274 52.93C11.3842 52.93 0 41.2386 0 26.8165C0 12.3954 11.3854 0.703125 25.4273 0.703125ZM50.8547 26.8165V26.8166C50.8547 26.8165 50.8547 26.8165 50.8547 26.8165Z"
        :fill="`${secondaryColor}` ? `#fff`:  `#007F80`"
      />
      <path
        d="M58.5764 60.8535L41.8008 43.625"
        :stroke="`${secondaryColor}` ? `#fff`: `#007F80`"
        stroke-width="8"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      width="163"
      height="163"
      viewBox="0 0 163 163"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      >
      <circle
        cx="81.5"
        cy="81.5"
        r="81"
        :fill="`${secondaryColor}` || `#E3F8F8`"
        :fill-opacity="`${secondaryColor}` ? `1`:`0.5`"
      />
    </svg>
  </div>
</template>

<style scoped>
.center-icon {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
